// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3E3J7","inner":"Form_inner__26-UA","range":"Form_range__1oQ8o","name":"Form_name__2jfhM","actions":"Form_actions__3cSFO"};